const $body = $('body');

function initPagination() {
    $('.pagination').each(function () {
        $('a', this).addClass('btn btn--theme btn--outline btn--small-padding');

        $('a:not(.prev):not(.next)', this).wrapInner('<span class="btn__split"></span>');

        $('span.page-numbers.dots', this).addClass('btn btn--theme btn--outline btn--small-padding');
        $('span.page-numbers.current', this).addClass('btn btn--theme btn--small-padding');
    });

    $body.trigger('buttonsUpdated'); // retriggers initSplitButtons() in btns.js
}

$body.on('initScripts pageTransitionComplete', function() {
    initPagination();
});
